export default "__VITE_ASSET__Dry19Q2___"